export const oxxioNavlinkOncolorColors = {
  navLinkSecondaryOnColorDefault: '{{ neutralColors.neutralWhite }}',
  navLinkSecondaryOnColorHover: '{{ neutralColors.neutralWhite }}',
  navLinkSecondaryOnColorFocusOutline: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorDefault: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorHover: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorFocusOutline: '{{ neutralColors.neutralWhite }}',
};
